import type { ContentfulPlaceholderServiceFragment } from '@/graphql/contentful/api';

import { renderContentfulPlaceholderServiceSection } from './cms';

export const PlaceholderService = (
  props: ContentfulPlaceholderServiceFragment,
) => {
  return <>{renderContentfulPlaceholderServiceSection(props)}</>;
};
